import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class DepositMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.deposit.depositMapperError"));

        Object.setPrototypeOf(this, DepositMapperError.prototype);
    }
}